export const functionToolParameterTypes = ['string', 'integer', 'number', 'boolean', 'array', 'object'] as const;

export const functionToolArrayItemTypes = functionToolParameterTypes.filter(
    (type): type is Exclude<FunctionToolParameterType, 'array'> => type !== 'array',
);

export type FunctionToolParameterType = (typeof functionToolParameterTypes)[number];
export type FunctionToolArrayItemType = (typeof functionToolArrayItemTypes)[number];

export interface FunctionToolParameter {
    type: FunctionToolParameterType;
    description?: string;
    required?: boolean;
    items?: FunctionToolParameter;
    properties?: Record<string, FunctionToolParameter>;
    enum?: string[];
}

export interface FunctionToolDefinition {
    name: string;
    description?: string;
    strictMode?: boolean;
    parameters: Record<string, FunctionToolParameter>;
}
